module.exports = __webpack_public_path__ + "static/img/8.90cef01.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/8.png
// module id = i7hT
// module chunks = 0